import React from 'react';
import Modal from './Modal';
import Button from './Button';
import {AppText} from './Typography';
import {AlertCircle, CheckCircle, XCircle} from 'lucide-react';

interface ConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  variant?: 'danger' | 'warning' | 'success';
  isLoading?: boolean;
  confirmButtonVariant?: 'primary' | 'secondary' | 'outline' | 'danger' | 'ghost';
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'تأكيد',
  cancelText = 'إلغاء',
  variant = 'warning',
  isLoading = false,
  confirmButtonVariant = 'primary'
}) => {
  const getIcon = () => {
    switch (variant) {
      case 'danger':
        return <XCircle size={48} className="mx-auto text-red-500 mb-4" />;
      case 'success':
        return <CheckCircle size={48} className="mx-auto text-green-500 mb-4" />;
      case 'warning':
      default:
        return <AlertCircle size={48} className="mx-auto text-yellow-500 mb-4" />;
    }
  };

  const getConfirmButtonVariant = () => {
    if (confirmButtonVariant !== 'primary') {
      return confirmButtonVariant;
    }

    switch (variant) {
      case 'danger':
        return 'danger';
      case 'success':
        return 'primary';
      case 'warning':
      default:
        return 'primary';
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      width="max-w-md"
    >
      <div className="text-center">
        {getIcon()}
        <AppText className="text-lg mb-4">{message}</AppText>
        <div className="flex gap-4 justify-center">
          <Button
            variant="ghost"
            onClick={onClose}
            disabled={isLoading}
          >
            {cancelText}
          </Button>
          <Button
            variant={getConfirmButtonVariant()}
            onClick={onConfirm}
            isLoading={isLoading}
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationDialog;
